<script setup lang="ts">
// First run in the apps: which hrth server? Paste its address or any link from it (an
// invite, a device link), or scan its QR code; the link's page opens once the server answers.
import { ref } from 'vue'
import { connectTo } from '../lib/connect'
import AuthFrame from '../components/AuthFrame.vue'
import ScanButton from '../components/ScanButton.vue'

const input = ref('')
const busy = ref(false)
const error = ref<string | null>(null)

async function connect(): Promise<void> {
  busy.value = true
  error.value = null
  const failed = await connectTo(input.value)
  // On success the page reloads on the server.
  if (failed) {
    error.value = failed
    busy.value = false
  }
}

function scanned(text: string): void {
  input.value = text
  void connect()
}
</script>

<template>
  <AuthFrame testid="connect" caption="connect">
      <h1 class="mb-2 text-3xl font-light tracking-tight">Connect to your hrth</h1>
      <p class="mb-5 text-sm text-text-muted">
        Enter your server’s address, or paste the invite link someone sent you.
      </p>
      <form class="space-y-4" @submit.prevent="connect">
        <div>
          <label class="label" for="connect-server">Server or invite link</label>
          <input
            id="connect-server"
            v-model="input"
            class="input mono"
            placeholder="hrth.example.org"
            autocomplete="url"
            autocapitalize="off"
            spellcheck="false"
            data-testid="connect-server"
          />
        </div>
        <p v-if="error" class="border border-signal px-3 py-2 text-sm text-error" data-testid="connect-error">
          {{ error }}
        </p>
        <button class="btn-primary w-full" :disabled="busy || !input.trim()" data-testid="connect-submit">
          {{ busy ? 'Connecting…' : 'Connect' }}
        </button>
      </form>
      <div class="mt-3"><ScanButton @scanned="scanned" /></div>
  </AuthFrame>
</template>
